module.exports = __webpack_public_path__ + "static/img/left-bg.5562b8df.png";